'use client'
import { ItineraryItemV2 } from '@/types/itinerary/itineraryV2';
import { faCamera } from '@fortawesome/pro-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { ReactNode } from "react";

export default function Pin({
  color = "#FF5A1F",
  icon,
  index,
  place,
  isActive
}: {
  isActive?: boolean
  index?: number;
  place: ItineraryItemV2;
  color?: string;
  icon: ReactNode;
}) {

  return (
    <div style={{ animationDelay: Math.random() + 's' }} id="pin-comp"
      className={`${isActive ? '' : ''} hover:z-20 z-[1000] group flex items-center justify-center transition-transform duration-300 hover:scale-105`} >


      <div className={`${isActive ? 'animate-bounce' : ''}`}>
        {
          index !== undefined && (
            <span
              style={{ borderColor: color, color }}
              className="absolute z-[1001] right-0 top-0   flex aspect-square h-6 w-6
                       translate-x-1/3 -translate-y-1/3 items-center justify-center rounded-full border bg-white px-0.5 text-center text-sm font-semibold"
            >
              {index + 1}
            </span>
          )}


        <div className={`relative`}>
          <span style={{ color }}
            className=" absolute size-7 rounded-full bg-white flex items-center justify-center
                       left-1/2 top-1.5  -translate-x-1/2 z-[1000] text-xs">
            {icon || <FontAwesomeIcon icon={faCamera} size='xl' className="w-5 h-5" />}
          </span>
          <svg className={` relative w-10`} viewBox="0 0 36 47" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M35.0527 21.3817L35.0495 21.3977L35.0473 21.4139C34.2761 27.2259 29.9893 33.5097 25.8173 38.3909C23.7416 40.8195 21.714 42.8786 20.2052 44.3307C19.451 45.0564 18.8271 45.6299 18.3923 46.0214C18.2554 46.1447 18.1373 46.2499 18.0398 46.3362C17.9662 46.2711 17.881 46.1953 17.7848 46.1091C17.4112 45.7742 16.8726 45.2824 16.2154 44.657C14.9006 43.406 13.113 41.6223 11.222 39.4925C7.42766 35.2189 3.26692 29.6058 1.62796 24.1339L1.62297 24.1172L1.61682 24.1009C0.895117 22.1874 0.5 20.1131 0.5 17.9455C0.5 8.3106 8.3106 0.5 17.9455 0.5C27.5803 0.5 35.3909 8.3106 35.3909 17.9455C35.3909 19.1222 35.2745 20.2712 35.0527 21.3817Z" fill={color} stroke="white" />
          </svg>

        </div>






      </div>
    </div>
  );
};